
import { SearchOutlined } from '@ant-design/icons'
import { Input, Table } from 'antd'
import React from 'react'
// eslint-disable-next-line
import { buscar_cantidad_aspirantes } from '../functions/arreglos'
import { useLoginStore } from '../stores/useLoginStore'
import { EmptyPersonalizado } from './EmptyPersonalizado'
import useReporteGeneralMaestria from '../hooks/adminexamen/useReporteGeneralMaestria'


// eslint-disable-next-line
const ReporteGeneralMaestria = ({ pk_carrera = 0 }) => {

  const objLogueado = useLoginStore( store => store.objLogueado)
  const { datosReporteAlumnos, columns, loading, setTextoBuscar, textoBuscar } = useReporteGeneralMaestria( pk_carrera )
  // eslint-disable-next-line
  var titulo
  // eslint-disable-next-line
  var materia;

  // eslint-disable-next-line
  if ( pk_carrera === 0 ) {
    titulo = false
  } else {

    // ? no se porqué la variable se llama materia ;n;
    materia = objLogueado.carreras.find( e => {
      // eslint-disable-next-line
      return e.pk_carrera === pk_carrera
    })

    titulo = "Resultados de la carrera " + materia.carrera
  }

  // cantidad
  // eslint-disable-next-line
  const cantidad_aspirantes = buscar_cantidad_aspirantes( datosReporteAlumnos )

  // filtrando columna de inscribir
  // eslint-disable-next-line
  const columnas_que_no_quiero = [ 'Prematrícula', 'Inscribir' ];

  // aquí sólo traigo las columnas que no están en el arreglo "columnas_que_no_quiero"
  // eslint-disable-next-line
  const columnas_filtradas = columns.filter( a => !columnas_que_no_quiero.includes( a.title ) )

  return (
    <>
      <Table
        loading={ loading }
        // eslint-disable-next-line
        columns={ columnas_filtradas }
        rowKey="pk_aspirante"
        title = { () => (
            <>
              <h1 className='lead'>{ titulo }</h1>
              {/* eslint-disable-next-line */}
              <h1>{ cantidad_aspirantes }</h1>
              <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
            </>
        )}
        showSorterTooltip={ false }
        dataSource={ datosReporteAlumnos }
        locale={{ emptyText: <EmptyPersonalizado/> }}
      />
    </>
  )
}

export default ReporteGeneralMaestria
